import * as React from 'react';

import SuperCritical from 'lib/supercritical';

import { TitledTab } from 'portcall/pctabstrip/model';

import {
    CoordinationCardDetails,
    TabActions,
    TabLog,
    TabStatus
} from './model';

import {
    PCTabContents,
    PCTabStripView,
    TitledTabContentsController,
    TitledTabStripViewController
} from 'portcall/pctabstrip/view';

import { CoordinationCardDetailsActionsTabView as ActionsTabView } from './actionsview';
import { CoordinationCardDetailsLogTabView as LogTabView } from './logview';
import { CoordinationCardDetailsStatusTabView as StatusTabView } from './statusview';

export const CoordinationCardDetailsView = SuperCritical(({ model: m } : { model : CoordinationCardDetails }) =>
    <div className="coordinationcarddetails">
        <PCTabStripView
            model={m.TabStrip}
            ctrl={new TitledTabStripViewController()}
            extraContents={() =>
                <CoordinationCardDetailsCloseLink dismissDetails={m.DismissDetails} />
            }
        />
        <PCTabContents
            model={m.TabStrip}
            ctrl={new TabContentsController(m)}
        />
        <CoordinationCardDetailsLoadingIcon loading={m.Loading} />
    </div>
);

class TabContentsController extends TitledTabContentsController {
    constructor(readonly model : CoordinationCardDetails) { super(); }

    renderTabContents(tab : TitledTab) {
        const m = this.model;
        if      (tab === TabStatus ) return <StatusTabView model={m.StatusTab} />;
        else if (tab === TabActions) return <ActionsTabView model={m.ActionsTab} />;
        else if (tab === TabLog    ) return <LogTabView model={m.LogTab} />;
        else throw new Error(`Unknown tab with title '${tab.Title}'`);
    }
}

// UI fragments for consumption here and by the cancelled C-Card details view
export const CoordinationCardDetailsCloseLink = SuperCritical(({ dismissDetails } : { dismissDetails : () => void }) =>
    <span
        className="ccard-details__close-details-link fa fa-times-circle"
        onClick={dismissDetails}
    />
);

export const CoordinationCardDetailsLoadingIcon = SuperCritical(({ loading } : { loading : () => boolean }) =>
    loading() ? <div className="ccard-details__loading-icon" /> : null
);



// WEBPACK FOOTER //
// ./apps/portcall/coordinationcarddetails/view.tsx